var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Sentry from "@sentry/react";
export var camelToTitleCase = function (camelCaseString) {
    return camelCaseString
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, function (str) { return str.toUpperCase(); })
        .trim();
};
var formatCurrencyHelper = function () {
    return {
        style: "currency",
        currency: "USD",
    };
};
var formatPercentageHelper = function (num, errorValue) {
    if (errorValue === void 0) { errorValue = "TBD"; }
    if (num >= 0 && num <= 100) {
        // format to 2 decimal places
        num = Math.round(num * 100) / 100;
        return "".concat(num, "%");
    }
    return errorValue;
};
export var formatNumber = function (_a) {
    var value = _a.value, _b = _a.isCurrency, isCurrency = _b === void 0 ? false : _b, _c = _a.isPercentage, isPercentage = _c === void 0 ? false : _c, _d = _a.locale, locale = _d === void 0 ? "en-US" : _d;
    var num = parseFloat(value);
    var options = {};
    if (isNaN(num))
        return value;
    if (isPercentage)
        return formatPercentageHelper(num);
    // set options to use the appropriate formatter
    if (isCurrency)
        options = formatCurrencyHelper();
    var formatter = new Intl.NumberFormat(locale, __assign({}, options));
    return formatter.format(num);
};
export var formatDate = function (date, abbrevMonth, noDay) {
    if (abbrevMonth === void 0) { abbrevMonth = false; }
    if (noDay === void 0) { noDay = false; }
    if (!date)
        return date;
    var dateObj = new Date(date);
    if (isNaN(dateObj.getTime()))
        return date;
    return dateObj.toLocaleDateString("en-US", {
        timeZone: "UTC",
        year: "numeric",
        month: abbrevMonth ? "short" : "long",
        day: noDay ? undefined : "numeric",
    });
};
export var getCookie = function (name) {
    var nameEQ = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === " ")
            cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0)
            return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
};
export var eraseCookie = function (name) {
    document.cookie = "".concat(name, "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};
export var gtmPush = function (event, params) {
    if (params === void 0) { params = {}; }
    var dataLayer = window.dataLayer;
    try {
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push(__assign({ event: event }, params));
    }
    catch (err) {
        Sentry.captureException(err, {
            extra: {
                message: "Failed to Push Datalayer event",
            },
        });
    }
};
export var cx = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
};
export var getInitials = function (firstName, lastName) {
    var initials = "".concat((firstName === null || firstName === void 0 ? void 0 : firstName[0]) || "").concat((lastName === null || lastName === void 0 ? void 0 : lastName[0]) || "").trim();
    return initials || "SS";
};
